module.exports = __webpack_public_path__ + "static/media/muhiminul.88af36cd.png";